__turbopack_context__.v({
  "bondscreenerTab": "bondscreener-module-scss-module__l4Yt3W__bondscreenerTab",
  "cardWrapper": "bondscreener-module-scss-module__l4Yt3W__cardWrapper",
  "countLabel": "bondscreener-module-scss-module__l4Yt3W__countLabel",
  "isTabActive": "bondscreener-module-scss-module__l4Yt3W__isTabActive",
  "isTabDisabled": "bondscreener-module-scss-module__l4Yt3W__isTabDisabled",
  "rangeLabel": "bondscreener-module-scss-module__l4Yt3W__rangeLabel",
  "sizesFilterRow": "bondscreener-module-scss-module__l4Yt3W__sizesFilterRow",
  "tab": "bondscreener-module-scss-module__l4Yt3W__tab",
  "tabCountLabel": "bondscreener-module-scss-module__l4Yt3W__tabCountLabel",
  "tableFooterLabel": "bondscreener-module-scss-module__l4Yt3W__tableFooterLabel",
  "tableTabs": "bondscreener-module-scss-module__l4Yt3W__tableTabs",
  "tabsFooter": "bondscreener-module-scss-module__l4Yt3W__tabsFooter",
  "tabsFooterLine": "bondscreener-module-scss-module__l4Yt3W__tabsFooterLine",
  "tile": "bondscreener-module-scss-module__l4Yt3W__tile",
  "tileHeader": "bondscreener-module-scss-module__l4Yt3W__tileHeader",
  "tileSearchInputWrapper": "bondscreener-module-scss-module__l4Yt3W__tileSearchInputWrapper",
  "tileTabSelect": "bondscreener-module-scss-module__l4Yt3W__tileTabSelect",
});
